import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/baseURL";
import { setAlert } from "./alert.slice";
import axiosInstance from "../../utils/axiosInstance";
import Cookies from 'js-cookie';
const initialStateAccount = {
    VendorPayment: [],
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getVendorPayment = createAsyncThunk(
    'vendorPayment/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllVendorPayment', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log(response.data);
            return response.data.vendorPayment;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const createVendorPayment = createAsyncThunk(
    'vendorPayment/add',
    async (data, { dispatch, rejectWithValue }) => {
        console.log(data);
        try {
            const response = await axiosInstance.post(BASE_URL + '/createVendorPayment', data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getVendorPayment());
            return response.data.vendorPayment;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteVendorPayment = createAsyncThunk(
    'vendorPayment/delete',
    async (id, { dispatch, rejectWithValue }) => {
        // console.log(id);
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deleteVendorPayment/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getVendorPaymentById = createAsyncThunk(
    'vendorPayment/view',
    async (id, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getVendorPaymentById/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.vendorPayment;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const updateVendorPayment = createAsyncThunk(
    'vendorPayment/edit',
    async (data, { dispatch, rejectWithValue }) => {
        console.log("id", data);
        try {
            const response = await axiosInstance.put(`${BASE_URL}/updateVendorPayment/${data._id}`, data, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getVendorPayment());
            return response.data.vendorPayment;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getAllPaymentVendor = createAsyncThunk(
    'vendorPayment/getAll',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getAllPaymentVendor', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.purchaseData;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);



const VendorPaymentSlice = createSlice({
    name: 'vendorPayment',
    initialState: initialStateAccount,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getVendorPayment.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Vendor Payment...';
            })
            .addCase(getVendorPayment.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Vendor Payment fetched successfully';
                state.VendorPayment = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getVendorPayment.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Vendor Payment';
            })
            .addCase(createVendorPayment.pending, (state) => {
                state.loading = true;
                state.message = 'Adding vendor...';
            })
            .addCase(createVendorPayment.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.VendorPayment.push(action.payload);
                state.message = action.payload?.message || 'Vendor Payment added successfully';
            })
            .addCase(createVendorPayment.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add Vendor Payment';
            })
            .addCase(deleteVendorPayment.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting Vendor Payment...';
            })
            .addCase(deleteVendorPayment.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.users = state.VendorPayment.filter((user) => user._id !== action.payload);
                state.message = action.payload?.message || 'Vendor Payment deleted successfully';
            })
            .addCase(deleteVendorPayment.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete Vendor Payment';
            })
            .addCase(updateVendorPayment.pending, (state) => {
                state.loading = true;
                state.message = 'Editing Vendor Payment...';
            })
            .addCase(updateVendorPayment.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                if (Array.isArray(state.VendorPayment)) {
                    state.VendorPayment = state.VendorPayment.map(d =>
                        d._id === action.payload?._id ? action.payload : d
                    );
                }
                state.message = 'Vendor Payment updated successfully';
            })
            .addCase(updateVendorPayment.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Vendor Payment';
            })
            .addCase(getAllPaymentVendor.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching All Payment Vendor...';
            })
            .addCase(getAllPaymentVendor.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.purchaseData = Array.isArray(action.payload) ? action.payload : [];
                state.message = action.payload?.message || 'All Payment Vendor fetched successfully';
            })
            .addCase(getAllPaymentVendor.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch All Payment Vendor';
            })
    }
});


export default VendorPaymentSlice.reducer;